import React from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LoadingProvider } from "./contexts/LoadingContext";
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { AuthProvider } from "./contexts/authContext";
import { AdProvider } from './contexts/AdIntegration';
import '@capacitor-community/safe-area';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <Router>
    <LoadingProvider>
      <AuthProvider>
        <SubscriptionProvider>
          <AdProvider>
            <App />
          </AdProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </LoadingProvider>
  </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
